module.exports = __webpack_public_path__ + "media/violence1.55832648.mp4";